<template>
  <div class="home">
    <div class="home__top">
      <img class="home__top__img" src="../assets/image/home_1.png" alt="home_1">
      <div class="home__top__text1">新能源数字化运营服务商</div>
      <div class="home__top__text2">我们是聚焦互联网新能源出行市场一站式 <br>数字化零售运营解决方案提供商。</div>
    </div>
    <div class="home__middle">
      <div class="home__middle__item home__middle__item_1">
        <div class="home__middle__item__title">
          <p>数字化营销运营</p>
          <p>DIGITAL MARKETING OPERATIONS</p>
        </div>
        <div class="home__middle__item__text">
          <div class="home__middle__item__text__item" v-for="(item,index) in data" :key="index">
            <img :src="item.imgUrl" alt="home_2">
            <div class="text">
              <p>{{item.title}}</p>
              <div>{{item.text}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="home__middle__item home__middle__item_2">
        <div class="home__middle__item__title">
          <p>SAAS服务</p>
          <p>SAAS SERVICES</p>
          <div>把SAAS系统赋能给主机厂，打造主机厂自己的数字化系统</div>
        </div>
        <div class="home__middle__item__text home__middle__item__text_2">
          <img src="../assets/image/home_6.png" alt="home_6">
        </div>
      </div>
      <div class="home__middle__item home__middle__item_3">
        <div class="home__middle__item__title">
          <p class="p_3">业务布局</p>
          <p class="p_3">BUSINESS LAYOUT</p>
        </div>
        <div class="home__middle__item__text home__middle__item__text_3">
          <div class="home__middle__item__text__item home__middle__item__text__item_3" v-for="(item,index) in data2" :key="index">
            <img :src="item.imgUrl" alt="home_2">
            <div class="text">
              <p class="p_3">{{item.title}}</p>
              <div class="div_3">{{item.text}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="home__middle__item home__middle__item_4">
        <div class="home__middle__item__title">
          <p>我们的客户</p>
          <p>OUR CUSTOMERS</p>
        </div>
        <div class="home__middle__item__imgs home__middle__item__imgs__1">
          <img @mouseenter="e => enter(1,e)" @mouseleave="e => leave(1,e)" src="../assets/image/contact_logo1.png" alt="contact_logo1">
          <img @mouseenter="e => enter(2,e)" @mouseleave="e => leave(2,e)" src="../assets/image/contact_logo2.png" alt="contact_logo2">
          <img @mouseenter="e => enter(3,e)" @mouseleave="e => leave(3,e)" src="../assets/image/contact_logo3.png" alt="contact_logo3">
          <img @mouseenter="e => enter(4,e)" @mouseleave="e => leave(4,e)" src="../assets/image/contact_logo4.png" alt="contact_logo4">
        </div>
        <div class="home__middle__item__imgs">
          <img @mouseenter="e => enter(5,e)" @mouseleave="e => leave(5,e)" src="../assets/image/contact_logo5.png" alt="contact_logo5">
          <img @mouseenter="e => enter(6,e)" @mouseleave="e => leave(6,e)" src="../assets/image/contact_logo6.png" alt="contact_logo6">
          <img @mouseenter="e => enter(7,e)" @mouseleave="e => leave(7,e)" src="../assets/image/contact_logo7.png" alt="contact_logo7">
          <img @mouseenter="e => enter(8,e)" @mouseleave="e => leave(8,e)" src="../assets/image/contact_logo8.png" alt="contact_logo8">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imgUrl2 from '../assets/image/home_2.png'
import imgUrl3 from '../assets/image/home_3.png'
import imgUrl4 from '../assets/image/home_4.png'
import imgUrl5 from '../assets/image/home_5.png'

import imgUrl7 from '../assets/image/home_7.png'
import imgUrl8 from '../assets/image/home_8.png'
export default {
  name: 'Home',
  data(){
    return {
      data:[
        {
          imgUrl:imgUrl2,
          title:'内容运营',
          text:'创意策划及输出，短视频拍摄及投放运营，话题种草及话题运营，垂直媒体平台的内容发布及运营'
        },
        {
          imgUrl:imgUrl3,
          title:'社群运营',
          text:'打造新能源潮流社区 ，为用户的全生命周期服务，与用户互动互联，为用户打造自己的一片生态'
        },
        {
          imgUrl:imgUrl4,
          title:'用户运营',
          text:'通过走心的用户体验运营获取人群画像分析，官网行为分析，触媒习惯分析，转化周期分析，为提升转化提供更好的数据支持'
        },
        {
          imgUrl:imgUrl5,
          title:'平台运营',
          text:'天猫，京东，抖音，小红书等公域流量平台运营及车管家，用户APP等私域流量运营'
        }
      ],
      data2:[
        {
          imgUrl:imgUrl7,
          title:'数字化营销运营',
          text:'创意策划及输出，短视频拍摄及投放运营，话题种草及话题运营，垂直媒体平台的内容发布及运营'
        },
        {
          imgUrl:imgUrl8,
          title:'高端品牌打造',
          text:'创意策划及输出，短视频拍摄及投放运营，话题种草及话题运营，垂直媒体平台的内容发布及运营'
        }
      ]
    }
  },
  methods:{
    enter(index,e){
      let src = require('../assets/image/contact_logo' + index + '_h.png')
      e.target.src = src
    },
    leave(index,e){
      let src = require('../assets/image/contact_logo' + index + '.png')
      e.target.src = src
    }
  }
}
</script>

<style lang="scss" scoped>
.home{
  &__top{
    position: relative;
    width: 100%;
    &__img{
      width: 100%;
      min-width: 1440px;
      max-width: 1920px;
    }
    &__text1{
      width: 100%;
      position: absolute;
      text-align: center;
      color: #fff;
      font-size: 40px;
      top: 300px;
      line-height: 50px;
      font-family: webfont__bold;
    }
    &__text2{
      width: 100%;
      position: absolute;
      text-align: center;
      color: #F8F8F8;
      font-size: 15px;
      top: 360px;
      line-height: 24px;
    }
  }
  &__middle__item{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 130px 0px;
    width: 1440px;
    margin: 0 auto;
    &_2{
      background-color: #fff;
      padding-bottom: 0px;
    }
    &_3{
      background-image: url(../assets/image/home_9.png);
    }
    &_4{
      background-color: #fff;
    }
    &__title{
      font-size: 40px;
      color: #333;
      width: 880px;
      text-align: center;
      height: 60px;
      position: relative;
      p:first-child{
          font-size: 40px;
          margin-bottom: -15px;
          font-family: webfont__bold;
          &.p_3{
            color: #fff;
          }
      }
      p:nth-child(2){
        font-size: 34px;
        opacity: 0.07;
        &.p_3{
          color: #fff;
        }
      }
      div{
        font-size: 14px;
        margin-top: 10px;
      }
    }
    &__text{
      margin-top: 120px;
      width: 1440px;
      display: flex;
      justify-content: space-between;
      &>img{
        width: 1080px;
        margin-bottom: 50px;
      }
      &_2{
        justify-content: center;
      }
      &_3{
        width: 1200px;
        justify-content: space-around;
      }
      &__item{
        width: 330px;
        border-radius: 10px;
        background-color: #FFF;
        padding: 25px;
        &_3{
          background-color: transparent;
        }
        img{
          width: 120px;
          margin: 8px 0 40px 0;
          cursor: pointer;
          transition:  all 0.6s;
          &:hover{
            transform: translateY(-40px) scale(1.2);
          }
        }
        .text{
          p{
            font-size: 16px;
            color: #000;
            line-height: 20px;
            margin-bottom: 20px;
            font-family: webfont__medium;
            &.p_3{
              color: #fff;
            }
          }
          div{
            font-size: 14px;
            color: #333;
            line-height: 30px;
            &.div_3{
              color: #fff;
            }
          }
        }
      }
    }
    &__imgs{
      min-width: 1440px;
      &__1{
        margin-top: 50px;
      }
      img{
        width: 210px;
        margin: 30px 72px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue